import { useEffect, useCallback } from 'react';

interface UseInfiniteScrollProps {
    tableRef: React.RefObject<HTMLElement>;
    isLoading: boolean;
    loadMore: () => void;
    isLoadingMore: boolean;
}

const useInfiniteScroll = ({
    tableRef,
    isLoading,
    isLoadingMore,
    loadMore,
}: UseInfiniteScrollProps) => {
    const handleScroll = useCallback(() => {
        if (!tableRef.current || isLoading || isLoadingMore) return;

        const { scrollTop, scrollHeight, clientHeight } = tableRef.current;

        // Check if the user has scrolled to the bottom of the table
        if (scrollTop + clientHeight >= scrollHeight - 100) {
            loadMore();
        }
    }, [isLoading, loadMore, tableRef]);

    useEffect(() => {
        const tableElement = tableRef.current;
        if (!tableElement) return;

        // Attach scroll event listener
        tableElement.addEventListener('scroll', handleScroll);

        return () => {
            tableElement.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll, tableRef]);
};

export default useInfiniteScroll;
